import clsx from 'clsx'
import React from 'react'
import styles from './Box.module.sass'

export function Box(props: {
	children: React.ReactNode
	view?: 'wide' | 'half'
	posRelative?: boolean
	largePadding?: boolean
	marginTop?: number
	marginBottom?: number
}) {
	return (
		<div
			className={clsx(
				styles.wrapper,
				props.view === 'half' && styles.half,
				props.posRelative && styles['view-relative'],
				props.largePadding && styles['view-largePadding']
			)}
			style={{ marginTop: `${props.marginTop ?? 0}px`, marginBottom: `${props.marginTop ?? 0}px` }}>
			{props.children}
		</div>
	)
}
